type AnalyticsEventParams = {
  category?: string;
  label?: string;
  value?: number;
  [key: string]: any;
};

export const trackEvent = (action: string, params: AnalyticsEventParams = {}) => {
  const gtag = (window as any).gtag as ((...args: any[]) => void) | undefined;
  if (!gtag) return;

  gtag("event", action, {
    ...params,
  });
};

export const trackConversion = (overrides: Partial<AnalyticsEventParams> = {}) => {
  const gtag = (window as any).gtag as ((...args: any[]) => void) | undefined;
  if (!gtag) return;

  const sendTo =
    process.env.REACT_APP_GA_CONVERSION_SEND_TO

  gtag("event", "conversion", {
    send_to: sendTo,
    value: 1.0,
    currency: "GBP",
    ...overrides,
  });
};

